module.exports = __webpack_public_path__ + "img/i_textinfo.d0eb17a6.svg";